import React from 'react';

const AdminSettings = () => {
  return (
    <div className="bg-white p-6 md:p-8 rounded-lg shadow-md">
      <h1 className="text-2xl font-bold text-gray-800">Settings</h1>
      <p className="mt-4 text-gray-600">
        This is a placeholder page for the Settings section. You can add your application settings and configurations here.
      </p>
    </div>
  );
};

export default AdminSettings;
